import {DialogConfigInterface} from '../../../app/shared/components';

export const ResetPasswordResultDialogTitle = (isPasswordReset: boolean): string => {
    return isPasswordReset ? 'Reset password' : 'Resend confirmation email';
};

export const ResetPasswordResultDialogConfig = (isPasswordReset: boolean): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: true,
            failed: false,
            failedMessage: isPasswordReset ?
                'Password reset email could not be sent.' :
                'Confirmation email could not be sent.',
            succeedMessage: isPasswordReset ?
                'Password reset email has been sent.' :
                'Confirmation email has been sent.'
        },
        buttons: [],
        buttonsDisabled: true,
        buttonsHidden: true
    };
};
